module.exports = __webpack_public_path__ + "images/category_lp/pc/step3_47bbac2a112522bc0e0248d277f6f3b3.png";